// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addButton {
    align-self: flex-start;
}

.nextExecutionButton {
    align-self: flex-start;
    cursor: pointer;
    height: 40px;
    background: none;
    border: none;
    border-radius: 8px;
    box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/app/settings/scheduler/controls/triggercontrols/time.trigger.control.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".addButton {\n    align-self: flex-start;\n}\n\n.nextExecutionButton {\n    align-self: flex-start;\n    cursor: pointer;\n    height: 40px;\n    background: none;\n    border: none;\n    border-radius: 8px;\n    box-shadow: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
